import * as types from "./actionTypes"

export function fetchAllData() {
    return {
        type: types.FETCH_ALL_DATA,
    }
}
export function fetchAllDataSuccess(data) {
    return {
        type: types.FETCH_ALL_DATA_SUCCESS,
        payload: data,
    }
}
export function fetchAllPlans() {
    return {
        type: types.FETCH_ALL_PLANS,
    }
}
export function fetchAllPlansSuccess(data) {
    return {
        type: types.FETCH_ALL_PLANS_SUCCESS,
        payload: data,
    }
}

export function fetchCarSpecifications(car) {
    return {
        type: types.FETCH_CAR_SPECIFICATION,
        payload: car,
    }
}
export function fetchCarSpecificationsSuccess(status) {
    return {
        type: types.FETCH_CAR_SPECIFICATION_SUCCESS,
        payload: status,
    }
}

export function fetchAllPositionData(args) {
    return {
        type: types.FETCH_ALL_POSITION_DATA,
        payload: args,
    }
}

export function fetchAllPositionDataSuccess(data) {
    return {
        type: types.FETCH_ALL_POSITION_DATA_SUCCESS,
        payload: data,
    }
}
export function clearPositionData() {
    return {
        type: types.CLEAR_POSITION_DATA,
    }
}

export function setDataByFirstChar(data) {
    return {
        type: types.SET_DATA_BY_FIRST_CHAR,
        payload: data,
    }
}

export function addChip(chip) {
    return {
        type: types.ADD_CHIPS,
        payload: chip,
    }
}
export function deleteChip(index) {
    return {
        type: types.DELETE_CHIPS,
        payload: index,
    }
}
export function setPlanDetails(details) {
    return {
        type: types.SET_PLAN_DETAILS,
        payload: details,
    }
}
export function addNewPlan(from) {
    return {
        type: types.ADD_NEW_PLAN,
        payload: from,
    }
}
export function addNewPlanCancel() {
    return {
        type: types.ADD_NEW_PLAN_CANCEL,
    }
}

export function createNewPlan(plan) {
    plan["baseUrl"] = "root"
    return {
        type: types.CREATE_NEW_PLAN,
        payload: plan,
    }
}
export function fetchPlanForCopy() {
    return {
        type: types.FETCH_PLAN_COPY,
    }
}

export function fetchPlanForEdit(data) {
    return {
        type: types.FETCH_PLAN_EDIT,
        payload: data,
    }
}

export function fetchPlanForEditSuccess(plan) {
    return {
        type: types.FETCH_PLAN_EDIT_SUCCESS,
        payload: plan,
    }
}

export function updatePlan(plan) {
    return {
        type: types.UPDATE_PLAN,
        payload: plan,
    }
}
export function updatePlanSuccess() {
    return {
        type: types.UPDATE_PLAN_SUCCESS,
    }
}

export function createNewPlanSuccess() {
    return {
        type: types.CREATE_NEW_PLAN_SUCCESS,
    }
}

export function createNewPlanFailure() {
    return {
        type: types.CREATE_NEW_PLAN_FAILURE,
    }
}

export function setDefaultPlan(data, planCategory) {
    return {
        type: types.SET_DEFAULT_PLAN,
        payload: { data, planCategory },
    }
}

export function setDefaultPlanSuccess(data) {
    return {
        type: types.SET_DEFAULT_PLAN_SUCCESS,
        payload: data,
    }
}

export function deletePlan(data) {
    return {
        type: types.DELETE_PLAN,
        payload: data,
    }
}

export function deletePlanSuccess(data) {
    return {
        type: types.DELETE_PLAN_SUCCESS,
        payload: data,
    }
}

export function clearPlanDetails() {
    return {
        type: types.CLEAR_PLAN_DETAILS,
    }
}

export function clearPlans() {
    return {
        type: types.CLEAR_PLANS,
    }
}
